import React from 'react';

function InvoiceModal({ show, bookings, selectedBookings, formatPrice, onExportCSV, onClose }) {
  if (!show) return null;

  const selected = bookings.filter(b => selectedBookings.includes(b.id));

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content invoice-modal" onClick={(e) => e.stopPropagation()}>
        <h2>📄 Fakturaunderlag</h2>
        <p>Följande bokningar är redo för fakturering:</p>

        <div className="invoice-summary">
          <table>
            <thead>
              <tr>
                <th>Företag</th>
                <th>Kontakt</th>
                <th>Kurs</th>
                <th>Belopp</th>
              </tr>
            </thead>
            <tbody>
              {selected.map(booking => (
                <tr key={booking.id}>
                  <td>{booking.company}</td>
                  <td>{booking.participantFirstName} {booking.participantLastName}</td>
                  <td>{booking.courseInstance.course.name}</td>
                  <td>{formatPrice(booking.price)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="3"><strong>Totalt:</strong></td>
                <td><strong>
                  {formatPrice(selected.reduce((sum, b) => sum + parseFloat(b.price), 0))}
                </strong></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="modal-actions">
          <button className="btn btn-primary" onClick={onExportCSV}>📥 Exportera till Fortnox</button>
          <button className="btn btn-secondary" onClick={onClose}>Stäng</button>
        </div>
      </div>
    </div>
  );
}

function SmsModal({ show, message, setMessage, sending, smsTarget, selectedBookings, instances, selectedInstance, onSend, onClose }) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content sms-modal" onClick={(e) => e.stopPropagation()}>
        <h2>📱 Skicka SMS</h2>
        <p className="modal-subtitle">
          {smsTarget === 'instance' && selectedInstance !== 'all'
            ? `Till alla bekräftade deltagare på ${instances.find(i => i.id === parseInt(selectedInstance))?.course?.name || 'kursen'}`
            : smsTarget === 'selected'
              ? `Till ${selectedBookings.length} valda deltagare`
              : typeof smsTarget === 'object'
                ? `Till ${smsTarget.participantFirstName} ${smsTarget.participantLastName}`
                : 'Välj mottagare'}
        </p>

        <div className="form-group">
          <label>Meddelande (max 160 tecken)</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            maxLength={160}
            rows={4}
            placeholder="Skriv ditt SMS-meddelande här..."
            className="sms-textarea"
          />
          <div className="char-count">{message.length}/160 tecken</div>
        </div>

        <div className="modal-actions">
          <button className="btn btn-success" onClick={onSend} disabled={sending || !message.trim()}>
            {sending ? '⏳ Skickar...' : '📤 Skicka SMS'}
          </button>
          <button className="btn btn-secondary" onClick={onClose}>Avbryt</button>
        </div>
      </div>
    </div>
  );
}

export { InvoiceModal, SmsModal };
